// Az ÖSSZEGZÉS bevétel-száma — EGY helyen, hogy a kártya, az egyenleg és a haszonkulcs ne térhessen el.
//
// LEZÁRT hónapon a KISZÁMLÁZOTT TÉNY (user-döntés): a hónap már elszámolt, az egyenlegnek a valódi bevételből kell
// állnia, nem a szerződés-állományból számolt tervből. NYITOTT hónapon (és ha a tény-oldal nem elérhető) a TERV.

import type { RevenueForecastResponse } from '@atlas/contracts';

export interface SummaryRevenue {
  amount: string;
  /** `true` → a szám a kiszámlázott tény (lezárt hónap); `false` → a terv. */
  actual: boolean;
}

export function summaryRevenue(forecast: RevenueForecastResponse | undefined): SummaryRevenue {
  if (!forecast) return { amount: '0', actual: false };
  if (forecast.actual.closed) return { amount: forecast.actual.total, actual: true };
  return { amount: forecast.stats.selectedMonth, actual: false };
}
